import React from 'react'
import DesignContainer from './DesignContainer'

const Design = () => <DesignContainer data-test="component-design" />

export default Design
